let requestHandlers: Record<RequestHandlerTypes, (body: unknown) => unknown>;

export const setGlobalRequestHandlers = (
  h: Record<RequestHandlerTypes, (body: unknown) => unknown>
): void => {
  requestHandlers = h;
};

export const getGlobalRequestHandlers = (): Record<
  RequestHandlerTypes,
  (body: unknown) => unknown
> =>
  requestHandlers
    ? requestHandlers
    : {
        defaultErrorCondition: () => {},
        TranslatedCondition: () => {},
        DocumentNotFoundCondition: () => {},
        CasusReadonlyCondition: () => {},
        Aborted: () => {},
      };

export type RequestHandlerTypes =
  | 'defaultErrorCondition'
  | 'TranslatedCondition'
  | 'DocumentNotFoundCondition'
  | 'CasusReadonlyCondition'
  | 'Aborted';
